import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "d2c915b2-1698-42c9-944e-674d6a4ff566"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooterD2c915b2169842c9944e674d6a4ff566(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const Logo = AppStore.presets["Logo"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooterD2c915b2169842c9944e674d6a4ff566 footer`}>
      {props["links"] || <Navigation className="Links78a1dae9Ea50404689b4E971f876efab" parentTag={buildClassName("Links78a1dae9Ea50404689b4E971f876efab", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="Logo5f0b044a72004fc29ee29554fd2ae6a0" parentTag={buildClassName("Logo5f0b044a72004fc29ee29554fd2ae6a0", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="CopyrightF492d6ae9f9f425b826cA5d5fe2c3569" parentTag={buildClassName("CopyrightF492d6ae9f9f425b826cA5d5fe2c3569", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="GroupflowD1ba93be310f4f39A029Aae5a90da317" parentTag={buildClassName("GroupflowD1ba93be310f4f39A029Aae5a90da317", parentTag)} {...props} />}
    </footer>
  );
}

// id: "5f0b044a-7200-4fc2-9ee2-9554fd2ae6a0"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "d2c915b2-1698-42c9-944e-674d6a4ff566"
export function Logo5f0b044a72004fc29ee29554fd2ae6a0(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Logo5f0b044a72004fc29ee29554fd2ae6a0" parentTag={buildClassName("Logo5f0b044a72004fc29ee29554fd2ae6a0", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />
  );
}

// id: "f492d6ae-9f9f-425b-826c-a5d5fe2c3569"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "d2c915b2-1698-42c9-944e-674d6a4ff566"
export function CopyrightF492d6ae9f9f425b826cA5d5fe2c3569(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="CopyrightF492d6ae9f9f425b826cA5d5fe2c3569" parentTag={buildClassName("CopyrightF492d6ae9f9f425b826cA5d5fe2c3569", parentTag)} {...props} />
  );
}

// id: "78a1dae9-ea50-4046-89b4-e971f876efab"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "d2c915b2-1698-42c9-944e-674d6a4ff566"
export function Links78a1dae9Ea50404689b4E971f876efab(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="Links78a1dae9Ea50404689b4E971f876efab" parentTag={buildClassName("Links78a1dae9Ea50404689b4E971f876efab", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "d1ba93be-310f-4f39-a029-aae5a90da317"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "d2c915b2-1698-42c9-944e-674d6a4ff566"
export function GroupflowD1ba93be310f4f39A029Aae5a90da317(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="GroupflowD1ba93be310f4f39A029Aae5a90da317" parentTag={buildClassName("GroupflowD1ba93be310f4f39A029Aae5a90da317", parentTag)} {...props} />
  );
}

// id: "dcb77600-47f5-455a-8325-b722e7447478"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "5f0b044a-7200-4fc2-9ee2-9554fd2ae6a0"
export const LogoTypeDcb7760047f5455a8325B722e7447478 = "FOOTER";

// id: "4eb3df58-d37d-49c7-aaa8-ba61de041e6a"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "78a1dae9-ea50-4046-89b4-e971f876efab"
export const NavMenuSlug4eb3df58D37d49c7Aaa8Ba61de041e6a = "footer-nav";

// id: "b6f350df-7dc6-4f07-a674-25a45067dba9"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "5f0b044a-7200-4fc2-9ee2-9554fd2ae6a0"
export const ContentSlugB6f350df7dc64f07A67425a45067dba9 = "footer-logo";

const Components = {
  DefaultFooterD2c915b2169842c9944e674d6a4ff566,
  Logo5f0b044a72004fc29ee29554fd2ae6a0,
  CopyrightF492d6ae9f9f425b826cA5d5fe2c3569,
  Links78a1dae9Ea50404689b4E971f876efab,
  GroupflowD1ba93be310f4f39A029Aae5a90da317,
  LogoTypeDcb7760047f5455a8325B722e7447478,
  NavMenuSlug4eb3df58D37d49c7Aaa8Ba61de041e6a,
  ContentSlugB6f350df7dc64f07A67425a45067dba9
}

export default Components;